document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartAdditions', () => {
    return {
      adding: false,
      errorMessage: '',

      async addProduct(button) {
        if (this.adding) return;

        const card = button.closest('[data-cart-addition-card]');
        const variantSelector = card.querySelector(
          '[data-cart-addition-variant]'
        );

        const variantId = variantSelector
          ? variantSelector.value
          : button.dataset.variantId;

        if (!variantId) {
          this.errorMessage = 'Please choose an available option.';
          return;
        }

        this.adding = true;
        this.errorMessage = '';

        const formData = new FormData();

        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append(
          'sections',
          'drawer-cart-items,drawer-cart-footer,cart-item-count'
        );
        formData.append('sections_url', window.location.pathname);

        const config = fetchConfigDefaults('application/javascript');

        config.body = formData;
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        try {
          const response = await fetch(theme.routes.cart_add_url, config);
          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(
              data.description ||
                data.message ||
                window.theme.strings.cartError
            );
          }

          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'cross_sell_click',
              item_list_name: 'cart_additions',
              product_id: card.dataset.productId,
              product_name: card.dataset.productTitle,
              product_type: card.dataset.productType,
              offer_source: card.dataset.offerSource,
              variant_id: variantId,
            });
          }

          document.body.dispatchEvent(
            new CustomEvent('switch:cart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );
        } catch (error) {
          this.errorMessage =
            error.message || window.theme.strings.cartError;
        } finally {
          this.adding = false;
        }
      },
    };
  });
});